/**
 * Created by mukund on 8/2/15.
 */

/**
 * Created by mukund on 7/14/15.
 */
'use strict';

angular.module('mediacloudApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('protected', {
                parent: 'site',
                url: '/protected/:collectionId',
                params: {
                    destinationFolderId: null,
                    destinationFolderCollectionTree: null,
                    showUnpublished: false
                },
                data: {
                    roles: [],
                    pageTitle: 'collection.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/collection/templates/collection.html',
                        controller: 'CollectionController'
                    }
                },

                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('collection');
                        return $translate.refresh();
                    }]
                }
            });
    });
